/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [saada珍珠钱包首页] http://wiki.xunlei.cn/pages/viewpage.action?pageId=148316788
export const get_pearl_wallet_info = createAsyncThunk(
  'Saada/saadaWalletHome/get_pearl_wallet_info',
  async (p: any, store: any) => {
    const info = store.getState().env.deviceinfo
    const resp = await http.post(
      '/live/saada_settle/get_pearl_wallet_info',
      {
        ...info,
        mid: info.h_m,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// [查询用户7天内的失败订单数量以及最新一笔订单失败状态和原因] http://wiki.xunlei.cn/pages/viewpage.action?pageId=156941139
export const query_failed_order_info = createAsyncThunk(
  'Saada/saadaWalletHome/query_failed_order_info',
  async (p: {kind: number}, store: any) => {
    const info = store.getState().env.deviceinfo
    const resp = await http.post(
      '/live/saada_settle/query_failed_order_info',
      {
        ...info,
        mid: info.h_m,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 钱包信息类型定义
interface SimpleWallet {
  overage: string // 可提取的余额
  frozen_overage: string // 冻结、不可提取、审核通过的余额
  auditing_overage: string // 审核中的余额
  total: string // 总余额
}

// 图标列表项类型定义
interface IconListItem {
  name: string
  img: string
  url: string
  sign_status: string
  refund_red_dot: boolean
}

// 失败订单信息类型定义
interface FailedOrderInfo {
  failed_order_amount: number // 最近7天的失败订单数量
  failed_order_remind: {
    failed_reason_by_channel_partner: string // 合作方返回的打款失败原因
    possible_problems_by_saada: string // Saada识别到可能的问题
    suggestion: string // Saada对用户的建议
  }
  is_remind: boolean // 是否需要弹窗提示
}

// 钱包首页状态类型定义
interface InitialStateType {
  hide_withdraw?: boolean // 是否隐藏提现相关的信息
  simple_wallet?: SimpleWallet // 钱包信息
  icon_list?: IconListItem[] // 图标列表
  failed_order?: FailedOrderInfo // 失败订单信息
}

const initialState: InitialStateType = {}

export function useSaadaWalletHome() {
  return useSelector((store) => store.Animal_Beaver)
}

export const SaadaWalletHomeSlice = createSlice({
  name: 'Animal_Beaver',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_pearl_wallet_info.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(query_failed_order_info.fulfilled, (state, action) => {
      Object.assign(state, {failed_order: action.payload})
    })
  },
})

export default SaadaWalletHomeSlice.reducer
